import { render, staticRenderFns } from "./CustomReportsPanel.vue?vue&type=template&id=38e9c5e8&scoped=true"
import script from "./CustomReportsPanel.vue?vue&type=script&lang=js"
export * from "./CustomReportsPanel.vue?vue&type=script&lang=js"
import style0 from "./CustomReportsPanel.vue?vue&type=style&index=0&id=38e9c5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e9c5e8",
  null
  
)

export default component.exports